/** Unregisters service workers and deletes offline precache buckets (`bono-offline-*`). */
export async function clearBrowserOfflineShellCaches(): Promise<void> {
  const sw = globalThis.navigator?.serviceWorker;
  if (sw) {
    try {
      const regs = await sw.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    } catch {
      /* ignore */
    }
  }

  const cachesApi = globalThis.caches;
  if (!cachesApi) return;

  try {
    const all = await cachesApi.keys();
    await Promise.all(
      all
        .filter((name) => name.startsWith('bono-offline-'))
        .map(async (name) => {
          try {
            await cachesApi.delete(name);
          } catch {
            /* ignore */
          }
        }),
    );
  } catch {
    /* ignore */
  }
}
